import { useState } from "react"
import { useTranslation } from "react-i18next"
import * as S from "./styles"

interface Props {
    src: string
    title: string
    fullPage?: boolean
    fallbackHref?: string
}

export function ExternalResourcePage({ src, title, fullPage = false, fallbackHref }: Props) {
    const { t } = useTranslation()
    const [attempt, setAttempt] = useState(0)

    return (
        <section aria-label={title} style={fullPage ? S.fullPage : S.innerPage}>
            <h1 style={S.heading}>{title}</h1>
            <p style={S.hint}>{t("If this page is blank or unavailable, open it directly or try again later.")}</p>
            <div style={S.actions}>
                <a href={src} target="_blank" rel="noopener noreferrer" style={S.link}>
                    {t("Open")}
                </a>
                <button type="button" onClick={() => setAttempt(value => value + 1)} style={S.button}>
                    {t("Retry")}
                </button>
                {fallbackHref && (
                    <a href={fallbackHref} style={S.link}>
                        {t("Report a Bug")}
                    </a>
                )}
            </div>
            <iframe key={attempt} src={src} title={title} style={S.iframe} />
        </section>
    )
}
